import { render } from "./per_page_select.vue?vue&type=template&id=37606ee4&lang=pug"
import script from "./per_page_select.vue?vue&type=script&lang=js"
export * from "./per_page_select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__